import { MenuItem, Typography } from '@mui/material';
import { FunctionComponent, ReactNode } from 'react';
import { SelectItem } from './selectData';
import { TextField } from '@nps.today/component-library';

const componentDataTestId = 'single-select';

interface SingleSelectProps {
  items: SelectItem[];
  value: string | number;
  label: string;
  fullwidth?: boolean;
  helperText?: string;
  dataTestId: string;
  onChange: (newItem: SelectItem) => void;
  renderItem?: (item: SelectItem) => ReactNode;
}

export const SingleSelect: FunctionComponent<SingleSelectProps> = ({
  items,
  value,
  label,
  fullwidth = true,
  helperText,
  dataTestId,
  onChange,
  renderItem
}) => {
  return (
    <TextField
      dataTestId={`${dataTestId}-${componentDataTestId}`}
      fullWidth={fullwidth}
      select
      label={label}
      value={value}
      onChange={(event: any) => {
        const value = event.target.value;
        const newSelectedValue = items.find((i) => i?.value === value) ?? items[0].value;
        onChange(newSelectedValue);
      }}
      SelectProps={{
        MenuProps: {
          sx: { '& .MuiPaper-root': { maxHeight: 260 } }
        }
      }}
      helperText={helperText}
    >
      {items.map((item, index) => (
        <MenuItem
          key={index}
          value={item.value}
          sx={{
            mx: 1,
            my: 0.5,
            borderRadius: 0.75,
            typography: 'body2',
            textTransform: 'capitalize'
          }}
          disabled={item.disabled}
        >
          {renderItem ? <>{renderItem(item)}</> : <Typography>{item.displayValue}</Typography>}
        </MenuItem>
      ))}
    </TextField>
  );
};
